var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCircleSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation/Add circle solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2212 22.3168C17.744 22.3168 22.2212 17.8396 22.2212 12.3168C22.2212 6.79392 17.744 2.31677 12.2212 2.31677C6.69834 2.31677 2.22119 6.79392 2.22119 12.3168C2.22119 17.8396 6.69834 22.3168 12.2212 22.3168ZM11.7212 17.3168C11.445 17.3168 11.2212 17.0929 11.2212 16.8168V13.3168H7.72119C7.44505 13.3168 7.22119 13.0929 7.22119 12.8168V11.8168C7.22119 11.5406 7.44505 11.3168 7.72119 11.3168H11.2212V7.81677C11.2212 7.54063 11.445 7.31677 11.7212 7.31677H12.7212C12.9973 7.31677 13.2212 7.54063 13.2212 7.81677V11.3168H16.7212C16.9973 11.3168 17.2212 11.5406 17.2212 11.8168V12.8168C17.2212 13.0929 16.9973 13.3168 16.7212 13.3168H13.2212V16.8168C13.2212 17.0929 12.9973 17.3168 12.7212 17.3168H11.7212Z",
    fill: "#0097A9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleSolid);
export default __webpack_public_path__ + "static/media/add-circle-solid.c00f81d5d8205a947e54cbfdd723eafb.svg";
export { ForwardRef as ReactComponent };